// src/utils/validationUtils.js

/**
 * Checks if a value is required based on config
 */
export function isRequired(value, fieldConfig) {
  if (!fieldConfig || !fieldConfig.required) return true;
  return value !== undefined && value !== null && value !== '';
}

/**
 * Validates email format
 */
export function isValidEmail(email) {
  // Standard, simple email regex
  const re = /^[\w.-]+@[\w.-]+\.[A-Za-z]{2,}$/;
  return re.test(String(email).trim());
}

/**
 * Validates password policy
 */
export function isValidPassword(value, fieldConfig) {
  if (!fieldConfig || !fieldConfig.required) return true;
  if (!value) return false;
  const containsUppercase = /[A-Z]/.test(value);
  const containsLowercase = /[a-z]/.test(value);
  const containsNumber = /[0-9]/.test(value);
  const containsSpecial = /[#?!@$%^&*-]/.test(value);
  const minL = fieldConfig.minLength || 0;
  const maxL = fieldConfig.maxLength || Infinity;
  const hasMinLength = value.length >= minL;
  const hasMaxLength = value.length <= maxL;
  return containsUppercase && containsLowercase && containsNumber && containsSpecial && hasMinLength && hasMaxLength;
}

/**
 * Checks if two values are the same
 */
export function isSameAs(value, compareTo) {
  return value === compareTo;
}
